export function getComponentElement(element) {
    if (element) {
        return element;
    }
    else {
        throw new Error("Cannot get CdpaComponent element based on the selector");
    }
}
